import SceButton from  "../../../../Common/CommonComponents/sceButton";
import {getLocalizedStringstwo} from'../twoFactorAuthenticationStrings';
import classes from '../TwoFactorAuth.scss';

function TwoFactorAuthVerified(props) {
    let strings = getLocalizedStringstwo('TwoFactorAuthentication');
    let verifiedIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Verified_Symbol.svg';
    return (
        <div className={classes.card}>
        <div className={[classes.verified ,'sce-center-alg',"sce-content-row"].join(" ")}>
            <div className={classes.verifiedIcon}> <img src={verifiedIcon} alt="Verified Icon" /> 
            <div className={classes.verifiedText}> {props.isEmail ? strings.emailVerified : strings.phoneVerified} </div>  
                <SceButton buttonType="primary" value="OK" onClick={()=>props.handleCloseClick("verified")}  />
            </div>
        </div>
        </div>
    );
}

export default TwoFactorAuthVerified;